import { memo } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { ItemTypes } from '../ItemTypes.js'
const style = {
  border: '1px dashed gray',
  padding: '0.5rem 1rem',
  marginBottom: '.5rem',
  // backgroundColor: 'white',
  cursor: 'move',
}
export const Card = memo(function Card({ id, text, moveCard, findCard, cardIndex, insertNewCard, handleAlertDeleteCard, changeCardText,
  pasteTop, pasteDown, replaceText, startSeconds, endSeconds }) {
  const originalIndex = findCard(id).index
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.CARD,
      item: { id, originalIndex },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item
        const didDrop = monitor.didDrop()
        if (!didDrop) {
          moveCard(droppedId, originalIndex)
        }
      },
    }),
    [id, originalIndex, moveCard],
  )
  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.CARD,
      hover({ id: draggedId }) {
        if (draggedId !== id) {
          const { index: overIndex } = findCard(id)
          moveCard(draggedId, overIndex)
        }
      },
    }),
    [findCard, moveCard],
  )
  const opacity = isDragging ? 0 : 1

  return (
    <div ref={(node) => drag(drop(node))} style={{ ...style, opacity, display: "flex", padding: "0px", backgroundColor: cardIndex % 2 ? "#BED754" : "#f5a374" }}>
      {/* <div style={{ width: "70px", display: "flex", height: "50px", flexDirection: "column", alignItems: "start" }}>
        <span >{startSeconds}</span>
        <span>{endSeconds}</span>
      </div> */}
      <button >{id}</button>
      <div style={{ width: "40px", marginRight: "5px" }}>
        <button onClick={() => { handleAlertDeleteCard(id, cardIndex) }}>del</button>
        <button onClick={() => { insertNewCard(cardIndex) }}>ins</button>
      </div>
      <textarea style={{ width: "100%", height: "100%", backgroundColor: cardIndex % 2 ? "#BED754" : "#f5a374" }} type="text" onChange={(e) => { changeCardText(cardIndex, e.target.value) }} value={text} />


      <div style={{ width: "40px" }}>
        <button onClick={() => { navigator.clipboard.writeText(text) }}>cp</button>
        <button onClick={async () => { replaceText(cardIndex, await navigator.clipboard.readText()) }}>rp</button>
      </div>
      <div style={{ width: "40px" }}>
        <button onClick={async () => { pasteTop(cardIndex, await navigator.clipboard.readText()) }}>pst</button>
        <button onClick={async () => { pasteDown(cardIndex, await navigator.clipboard.readText()) }}>psd</button>
      </div>
      {/* {text} */}
      {/* <div style={{width:"40px",textAlign:"center"}}>
        {cardIndex}
      </div> */}

    </div>
  )
})
